<template>
  <div class="wlx-site-manager-wrapper wlx-user-manager">
    <header class="site-manager-head-con" style="padding-top:20px;">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="stuName" placeholder="请输入证书类型名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getStudentResultInfo()">搜索</el-button>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>、
          <!-- <el-button type="primary" icon="el-icon-delete" @click="DeleteAllDialogVisible = true">删除</el-button> -->
        </el-form-item>
      </el-form>
    </header>

    <el-table :data="list">
      <el-table-column label="序号" type="index"></el-table-column>
      <el-table-column prop="CertificateName" label="证书类型名称"></el-table-column>
      <el-table-column prop="DateCreated" label="创建日期"></el-table-column>
      <!-- <el-table-column prop label="证书类型">
        <template slot-scope="scope">
          <span v-if="scope.row.isCJ">初级</span>
          <span v-if="scope.row.isZJ">中级</span>
          <span v-if="scope.row.isGJ">高级</span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="编辑" :modal="false" :visible.sync="dialogFormVisible" width="800px">
      <el-form :inline="true" :model="from" class="demo-form-inline" label-width="200px">
        <el-form-item label="证书类型名称">
          <el-input v-model="from.name"></el-input>
        </el-form-item>
        <el-form-item label="证书封面">
          <imageUpload :url="urlAliyunOSS" :files.sync="from.certificateCover" format="image"></imageUpload>
        </el-form-item>
        <!-- <el-form-item label="证书包含初级">
          <el-radio v-model="isCJ" label="0">是</el-radio>
          <el-radio v-model="isCJ" label="1">否</el-radio>
        </el-form-item>
        <el-form-item label="证书包含中级">
          <el-radio v-model="isZJ" label="0">是</el-radio>
          <el-radio v-model="isZJ" label="1">否</el-radio>
        </el-form-item>
        <el-form-item label="证书包含高级">
          <el-radio v-model="isGJ" label="0">是</el-radio>
          <el-radio v-model="isGJ" label="1">否</el-radio>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelInfo">取 消</el-button>
        <el-button type="primary" @click="editInfo()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 批量删除 -->
    <el-dialog
      :before-close="cancel"
      title="批量删除"
      :visible.sync="DeleteAllDialogVisible"
      width="30%"
      top="3%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" label-width="120px" size="mini">
        <el-form-item label="开始时间">
          <el-date-picker v-model="deleteStartTime" type="datetime" placeholder="选择开始时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="deleteEndTime" type="datetime" placeholder="选择结束时间"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDeleteAll">取 消</el-button>
        <el-button type="primary" @click="deleteAll()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      checkList: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      stuName: "",
      schoolName: "",
      idCard: "",
      certificateNum: "",
      examinationTypeId: "",
      examinationGradeId: "",
      list: [],
      from: {
        id:"",
        name:"",
        certificateCover:""
      },
      files: [],
      urlAliyunOSS: "/api/design/osssign/getsign",
      //编辑信息
      dialogFormVisible: false,
      //导入
      ImportDialogVisible: false,
      uploadUrl: "/api/XOrg/CertificateManager/uploadExcel",
      fileList: [], //导入文件
      errorList: [], //错误信息
      certTypeList: [],
      certGradeList: [],
      certTypeId: "",
      searchCertTypeList: [],
      searCertGradeList: [],
      // 批量删除
      DeleteAllDialogVisible: false,
      deleteStartTime: "",
      deleteEndTime: "",
      isCJ:1,
      isZJ:1,
      isGJ:1,
    };
  },
  components: {
    imageUpload,
  },
  created() {
    this.getStudentResultInfo();
    // this.getCertificateType();
    // this.getSearchCertificateType();
  },
  methods: {
    handleCheckedCitiesChange(val){
      debugger;
    },
    deleteAll() {
      var that = this;
      this.$confirm("此操作将删除该时间段证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/CertificateManager/deleteCertificateAll", {
            startTime: this.deleteStartTime,
            endTime: this.deleteEndTime,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.DeleteAllDialogVisible = false;
              that.getStudentResultInfo();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    cancelDeleteAll() {
      this.DeleteAllDialogVisible = false;
      this.deleteStartTime = "";
      this.deleteEndTime = "";
    },
    getSearchCertificateType() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateTypeManager/getCertificateType")
        .then(function (rst) {
          if (rst.code > 0) {
            that.searchCertTypeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getSearchCertificateGrade() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
          typeId: this.examinationTypeId,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.searCertGradeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getCertificateType() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateTypeManager/getCertificateType")
        .then(function (rst) {
          if (rst.code > 0) {
            that.certTypeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    typeChnage() {
      // this.getCertificateGrade();
      this.from.examinationGradeId = "";
    },
    getCertificateGrade() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
          typeId: this.from.examinationTypeId,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.certGradeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    cancelInfo() {
      this.from.name="";
      this.dialogFormVisible = false;
    },
    onSuccess(res) {
      if (res.code < 0) {
        if (res.code === -5) {
          this.errorList = res.list;
        } else {
          this.$message.warning(res.msg);
        }
      } else {
        this.ImportDialogVisible = false;
        this.$message.success("导入成功");
        this.fileList = [];
        this.getStudentResultInfo();
      }
    },
    //清除数据
    cancel() {
      this.ImportDialogVisible = false;
      this.fileList = [];
    },
    addInfo() {
      this.dialogFormVisible = true;
    },
    //编辑
    editInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/Certificate/addOrEditCertificate", {
          id: this.from.id,
          name: this.from.name,
          certificateCover:this.from.certificateCover
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.cancelInfo();
            that.getStudentResultInfo();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //弹出框赋值
    handleEdit(row) {
      this.from.id = row.id;
      this.from.name = row.CertificateName;
      this.from.certificateCover = row.CertificateCover;
      this.dialogFormVisible = true;
    },
    //删除
    deleteInfo(id) {
      var that = this;
      this.$confirm("此操作将删除该证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/Certificate/deleteCertificate", {
            ids: id,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.getStudentResultInfo();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    //获取列表
    getStudentResultInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/Certificate/getCertificateList")
        .then(function (rst) {
          if (rst.code > 0) {
            that.list = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
  .demo-form-inline {
    .el-input__inner {
      width: 200px;
    }
    .img_upload {
      width: 500px;
    }
  }
}
</style>